import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

    private isBrowser: boolean;

    // 1. Inyectamos PLATFORM_ID para poder diferenciar entre servidor y navegador.
    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        // 2. Guardamos en una
        // propitiated si estamos o no en un navegador.
        this.isBrowser = isPlatformBrowser(this.platformId);
    }


    /**
     * Guarda un valor en localStorage, convirtiéndolo a JSON.
     * @param key La clave bajo la cual se guardará el valor.
     * @param value El valor a guardar (puede ser cualquier objeto).
     */
    setItem(key: string, value: any): void {
        if (this.isBrowser) {
            try {
                localStorage.setItem(key, JSON.stringify(value));
            } catch (e) {
                console.error('Error guardando en localStorage', e);
            }
        }
    }

    /**
     * Obtiene un valor de localStorage, convirtiéndolo desde JSON.
     * @param key La clave del valor a obtener.
     * @returns El objeto guardado, o null si no se encuentra o hay un error.
     */
    getItem<T>(key: string): T | null {
        if (this.isBrowser) {
            try {
                const item = localStorage.getItem(key);
                return item ? JSON.parse(item) : null;
            } catch (e) {
                console.error('Error obteniendo de localStorage', e);
                return null;
            }
        }
        return null; // Si no está en el navegador, siempre devuelve null.
    }


    // getStorageObject(type: string, name: string) {
    //     let elementStorage = JSON.parse(localStorage.getItem(type)) || {};
    //     if (elementStorage && `${elementStorage}.${name}`) {
    //         elementStorage = elementStorage[name];
    //     } else {
    //         elementStorage = {};
    //     }
    //     return elementStorage;
    // }

    /**
     * Elimina un valor de localStorage, solo si se ejecuta en el navegador.
     * @param key La clave del valor a eliminar.
     */
    removeItem(key: string): void {
        if (this.isBrowser) {
            localStorage.removeItem(key);
        }
    }

    /**
     * Limpia todo el localStorage, solo si se ejecuta en el navegador.
     */
    clear(): void {
        if (this.isBrowser) {
            localStorage.clear();
        }
    }
}
